import Collection from '../../collection';
import Cluster from '../../model/refbooks/cluster';





export default Collection.extend( {
	endpoint: 'clusters/list?apiVersion=2.0',
	responseAt: 'items',
    model: Cluster
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/clusters.js